import { c as _c } from "react/compiler-runtime";
import { IcoFileSearch24, IcoSparkles16 } from '@onefootprint/icons';
import type { PiiJsonValue } from '@onefootprint/request-types/dashboard';
import { CodeBlock, Divider, SegmentedControl } from '@onefootprint/ui';
import capitalize from 'lodash/capitalize';
import lowerCase from 'lodash/lowerCase';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import CollapsibleSection from '../collapsible-section';
type AgentExtractionDataProps = {
  extractions: PiiJsonValue[];
};
const AgentExtractionData = t0 => {
  const $ = _c(40);
  const {
    extractions
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "fieldset.documents.details.agentExtractionData"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t1);
  const [toggleSetting, setToggleSetting] = useState("data");
  let t2;
  if ($[1] !== t) {
    t2 = t(_temp);
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t) {
    t3 = t(_temp2);
    $[3] = t;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t) {
    t4 = t(_temp3);
    $[5] = t;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t4) {
    t5 = {
      label: t4,
      value: "data"
    };
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t) {
    t6 = t(_temp4);
    $[9] = t;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t6) {
    t7 = {
      label: t6,
      value: "json"
    };
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t5 || $[14] !== t7) {
    t8 = [t5, t7];
    $[13] = t5;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t3 || $[17] !== t8 || $[18] !== toggleSetting) {
    t9 = <div className="**:w-full"><SegmentedControl size="compact" aria-label={t3} options={t8} value={toggleSetting} onChange={setToggleSetting} /></div>;
    $[16] = t3;
    $[17] = t8;
    $[18] = toggleSetting;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== extractions || $[21] !== toggleSetting) {
    t10 = toggleSetting === "data" && <div className="flex flex-col gap-2">{extractions.map(_temp5)}</div>;
    $[20] = extractions;
    $[21] = toggleSetting;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== extractions || $[24] !== toggleSetting) {
    t11 = toggleSetting === "json" && <CodeBlock language="json" hideHeader={true} isPrivate={true}>{JSON.stringify(extractions, null, 2)}</CodeBlock>;
    $[23] = extractions;
    $[24] = toggleSetting;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  let t12;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <Divider />;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <IcoSparkles16 color="tertiary" />;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  let t14;
  if ($[28] !== t) {
    t14 = t(_temp6);
    $[28] = t;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  let t15;
  if ($[30] !== t14) {
    t15 = <div className="flex flex-col gap-3">{t12}<div className="flex gap-1 items-center justify-center">{t13}<p className="text-caption-1 text-tertiary">{t14}</p></div></div>;
    $[30] = t14;
    $[31] = t15;
  } else {
    t15 = $[31];
  }
  let t16;
  if ($[32] !== t10 || $[33] !== t11 || $[34] !== t15 || $[35] !== t9) {
    t16 = <div className="flex flex-col gap-4 w-full">{t9}{t10}{t11}{t15}</div>;
    $[32] = t10;
    $[33] = t11;
    $[34] = t15;
    $[35] = t9;
    $[36] = t16;
  } else {
    t16 = $[36];
  }
  let t17;
  if ($[37] !== t16 || $[38] !== t2) {
    t17 = <CollapsibleSection icon={IcoFileSearch24} title={t2} defaultOpen={true}>{t16}</CollapsibleSection>;
    $[37] = t16;
    $[38] = t2;
    $[39] = t17;
  } else {
    t17 = $[39];
  }
  return t17;
};
export default AgentExtractionData;
function _temp($) {
  return $.title;
}
function _temp2($_0) {
  return $_0.toggle.ariaLabel;
}
function _temp3($_1) {
  return $_1.toggle.data;
}
function _temp4($_2) {
  return $_2.toggle.json;
}
function _temp5(extraction) {
  return Object.keys(extraction).map(key => {
    const value = extraction[key as keyof PiiJsonValue];
    return <div key={key} className="flex justify-between gap-4 min-w-0"><p className="text-body-2 text-tertiary shrink-0">{capitalize(lowerCase(key))}</p><p className="text-body-2 text-primary text-right truncate min-w-0" data-dd-privacy="mask">{value ? value.toString() : "-"}</p></div>;
  });
}
function _temp6($_3) {
  return $_3.dataExtractedWith;
}